import React, { useState } from 'react';
import { FiCpu, FiUserPlus, FiStar } from 'react-icons/fi';

const DetailInformasi = ({
  workOrder,
  localProgress,
  setLocalProgress,
  isUpdatingProgress,
  onUpdateProgress
}) => {
  const handleSliderChange = (e) => {
    setLocalProgress(parseInt(e.target.value));
  };

  const handleSliderRelease = (e) => {
    const val = parseInt(e.target.value);
    onUpdateProgress(val);
  };

  const handleSetComplete = () => {
    onUpdateProgress(100);
  };

  return (
    <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <h3 className="text-base font-semibold text-[var(--text-primary)] mb-3 flex items-center gap-2">
        <FiCpu size={16} />
        <span>Informasi Pekerjaan</span>
      </h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Kategori</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{workOrder.category}</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Objek Pekerjaan</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">{workOrder.categoryItem || '-'}</p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Tanggal Mulai</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">
            {workOrder.startDate ? new Date(workOrder.startDate).toLocaleDateString('id-ID') : '-'}
          </p>
        </div>
        <div>
          <p className="text-xs text-[var(--text-secondary)]">Target Selesai</p>
          <p className="text-sm text-[var(--text-primary)] font-medium">
            {workOrder.targetDate ? new Date(workOrder.targetDate).toLocaleDateString('id-ID') : '-'}
          </p>
        </div>
      </div>

      <div className="mt-3">
        <p className="text-xs text-[var(--text-secondary)]">Deskripsi</p>
        <p className="text-sm text-[var(--text-primary)] mt-0.5">{workOrder.description || '-'}</p>
      </div>

      {/* PROGRESS BAR */}
      <div className="mt-4 pt-4 border-t border-[var(--border-color)]">
        <div className="flex justify-between items-center mb-1">
          <span className="text-xs text-[var(--text-secondary)]">Progress Pengerjaan</span>
          <span className="text-sm font-semibold text-[var(--text-primary)]">
            {workOrder.progress || 0}%
          </span>
        </div>
        <div className="w-full h-2.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
          <div 
            className={`h-full rounded-full transition-all duration-700 ease-out ${
              (workOrder.progress || 0) >= 80 ? 'bg-green-500' :
              (workOrder.progress || 0) >= 50 ? 'bg-yellow-500' :
              'bg-blue-500'
            }`}
            style={{ width: `${Math.min(workOrder.progress || 0, 100)}%` }}
          />
        </div>
        
        {/* SLIDER MANUAL PROGRESS */}
        <div className="mt-3 flex items-center gap-3">
          <input
            type="range"
            min="0"
            max="100"
            step="10"
            value={localProgress}
            onChange={handleSliderChange}
            onMouseUp={handleSliderRelease}
            onTouchEnd={handleSliderRelease}
            disabled={isUpdatingProgress}
            className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600 disabled:opacity-50"
          />
          
          <span className="text-xs font-semibold text-[var(--text-primary)] min-w-[40px] text-right">
            {localProgress}%
          </span>
          
          <button
            onClick={handleSetComplete}
            disabled={isUpdatingProgress}
            className="px-3 py-1 text-xs bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors disabled:opacity-50"
            title="Set progress ke 100%"
          >
            {isUpdatingProgress ? '...' : '✓ 100%'}
          </button>
        </div>
        
        <div className="flex justify-between text-xs text-[var(--text-secondary)] mt-1">
          <span>Estimasi: {workOrder.estimatedHours} jam</span>
          {workOrder.startDate && workOrder.targetDate && (
            <span>
              {Math.ceil((new Date(workOrder.targetDate) - new Date()) / (1000 * 60 * 60 * 24))} hari tersisa
            </span>
          )}
          {workOrder.actualHours > 0 && (
            <span>Realisasi: {workOrder.actualHours} jam</span>
          )}
        </div>
      </div>

      {/* TEAM */}
      {workOrder.team && workOrder.team.length > 0 && (
        <div className="mt-3 pt-3 border-t border-[var(--border-color)]">
          <h4 className="text-xs font-semibold text-[var(--text-secondary)] mb-2 flex items-center gap-2">
            <FiUserPlus size={14} />
            <span>Tim Pengerjaan ({workOrder.team.length} orang)</span>
          </h4>
          <div className="flex flex-wrap gap-2">
            {workOrder.team.map((member, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border ${
                  member.isLead 
                    ? 'bg-yellow-50 border-yellow-300 text-yellow-800' 
                    : 'bg-blue-50 border-blue-200 text-blue-800'
                }`}
              >
                {member.isLead && <FiStar size={10} className="text-yellow-500" />}
                <span className="font-medium">{member.name}</span>
                <span className="text-[var(--text-secondary)] text-[10px]">
                  ({member.role || 'Anggota'} • {member.hours || 0}j)
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailInformasi;